<template>
    <v-container id="sample-reference-table" class="py-0">
        <div class="title title-blue"><TranslatableStringComponent :tstring="{string: 'selectUpTo3FreeSamples'}" />:</div>
        <v-btn-toggle
            v-model="selectedButtons"
            multiple
            class="d-block"
            max="3"
        >
            <v-expansion-panels
                v-if="sampleCategory"
                :multiple="true"
                :focusable="true"
                :hover="true"
            >
                <v-expansion-panel v-for="(item, i) in sampleCategory" :key="i">
                    <v-expansion-panel-header>
                        <div class="d-flex align-center justify-space-between">
                            {{
                                item.title.en
                            }}<br/>
                            <v-chip
                            class="mr-2"
                            outlined
                            style="width:fit-content"
                            v-show="getNoOfItemsSelected(item._id)!==0"
                            >
                                {{getNoOfItemsSelected(item._id)}}
                            </v-chip>
                        </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="content-panel">
                        <div
                            v-for="product in productsAsPerCategory(item._id)"
                            :key="product._id"
                        >
                            <v-alert dense outlined color="#0063A6">
                                <p class="subtitle-1 mb-0">
                                    {{ product.title.en }}
                                </p>
                                <p class="body-2 font-weight-regular">
                                    {{ product.description.en }}
                                </p>

                                <v-btn
                                    :value="product._id"
                                    outlined
                                    color="#0063A6"
                                    block
                                    dense
                                    small
                                    @click="addSample(product,item._id,'add')"
                                    v-show="!selectedButtons.includes(product._id)"
                                    ><TranslatableStringComponent :tstring="{string: 'add'}" /></v-btn>
                                    
                                    <v-btn
                                    :value="product._id"
                                    outlined
                                    color="#0063A6"
                                    block
                                    dense
                                    small
                                    @click="addSample(product,item._id,'remove')"
                                    v-show="selectedButtons.includes(product._id)"
                                    ><TranslatableStringComponent :tstring="{string: 'remove'}" /></v-btn>
                            </v-alert>
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-btn-toggle>
    </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue' 
export default {
    name: 'SampleReferenceTable',
    components: { TranslatableStringComponent },
    data() {
        return {
            noItemsSelected:0,
            
        }
    },
    computed: {
        ...mapGetters({
            sampleCategory: 'sampleReferenceTable/sampleCategory',
            sampleProduct: 'sampleReferenceTable/sampleProduct'
        }),
        selectedButtons: {
            get() {
                return this.$store.state.sampleReferenceTable.selectedButtons
            },
            set(v) {
                this.$store.commit(
                    'sampleReferenceTable/updateSelectedButtons',
                    v
                )
            }
        },
        selectedCategory(){
            return this.$store.state.sampleReferenceTable.selectedCategory
        }
    },
    mounted() {
        this.fetchSamples()
    },
    methods: {
        fetchSamples() {
            this.$store.dispatch('sampleReferenceTable/fetchSamples')
        },
        productsAsPerCategory(catId) {
            return this.sampleProduct.filter((item) => {
                return item.categories.some((c) => {
                    return c._id === catId
                })
            })
        },
        addSample(product,itemId,action) {
            
            this.$store.dispatch('sampleReferenceTable/addSample', product)
            action === 'add'?
            this.$store.commit('sampleReferenceTable/addSelectedCategory', itemId)
            :
            this.$store.commit('sampleReferenceTable/removeSelectedCategory', itemId)
        },
        getNoOfItemsSelected(itemId){
            var count = this.selectedCategory.reduce(function(n,val){
                return n + (val === itemId)
            },0)
            return count;
        }
    }
}
</script>
